export * from "ce/utils/licenseHelpers";
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import {
  isAdminUser,
  isFreePlan,
  isTrialLicense,
  shouldShowLicenseBanner,
} from "ee/selectors/organizationSelectors";
import { isAirgapped } from "ee/utils/airgapHelpers";
import store from "store";
import { customerPortalPlansUrl } from "ee/utils/billingUtils";
import { createMessage, UPGRADE } from "ee/constants/messages";
import { useRouteMatch } from "react-router";
import PageBannerMessage from "ee/pages/common/PageWrapperBanner";
import { Button } from "@appsmith/ads";
import { useIsCloudBillingEnabled } from "hooks/useIsCloudBillingEnabled";
import { WORKSPACE_SETTINGS_LICENSE_PAGE_URL } from "constants/routes";
export const getLicenseKey = () => {
  const state = store.getState();
  const licenseKey =
    state?.organization?.organizationConfiguration?.license?.key;

  return licenseKey || "";
};

export const pricingPageUrlSource = "BE";

export const ShowUpgradeMenuItem = () => {
  const isTrial = useSelector(isTrialLicense);
  const isAdmin = useSelector(isAdminUser);
  const isFree = useSelector(isFreePlan);
  const isAirgappedInstance = isAirgapped();

  const isCloudBillingEnabled = useIsCloudBillingEnabled();

  const handleUpgrade = useCallback(() => {
    if (isCloudBillingEnabled) {
      window.location.href = WORKSPACE_SETTINGS_LICENSE_PAGE_URL;
    } else {
      window.open(customerPortalPlansUrl, "_blank");
    }
  }, [isCloudBillingEnabled]);

  return (isTrial || isFree) && isAdmin && !isAirgappedInstance ? (
    <Button
      className="business-plan-menu-option mr-2"
      data-testid="t--upgrade-to-business"
      kind="secondary"
      onClick={handleUpgrade}
    >
      {createMessage(UPGRADE)}
    </Button>
  ) : null;
};

export const Banner = () => {
  const showBanner = useSelector(shouldShowLicenseBanner);
  const isHomePage = useRouteMatch("/applications")?.isExact;
  const isLicensePage = useRouteMatch("/license")?.isExact;

  return showBanner && (isHomePage || isLicensePage) ? (
    <PageBannerMessage />
  ) : null;
};
